import React, { useState } from 'react';

// Styles & Assets
import styles from './SelectEpisodeButton.module.css';
import { ReactComponent as ListSvg } from '../../../assets/icons/list.svg';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import Modal from '../../UI/Modal/Modal';
import DialogSelectEpisode from '../DialogSelectEpisode/DialogSelectEpisode';

// Models
interface Props {
    caseID: number;
}

const SelectEpisodeButton: React.FC<Props> = ({ caseID }) => {

    const { t } = useTranslation();

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <button
                className={`button ${styles.buttonSelectEpisode}`}
                onClick={() => setShowModal(true)}
            >
                {t('episode_selection')}
                <ListSvg />
            </button>
            <Modal show={showModal} setShowModal={setShowModal}>
                <DialogSelectEpisode
                    currentCaseID={caseID}
                    closeModal={() => setShowModal(false)}
                />
            </Modal>
        </>
    );
};

export default SelectEpisodeButton;